import { render, staticRenderFns } from "./VolunteerProfileDetails.vue?vue&type=template&id=55eed10e"
import script from "./VolunteerProfileDetails.vue?vue&type=script&lang=ts"
export * from "./VolunteerProfileDetails.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerProfileDetails.vue?vue&type=style&index=0&id=55eed10e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports